import { AxiosInstance } from 'axios';

import { PayloadRequestMutationModel, PermissionModel } from '../models';
import { PERMISSION_ENDPOINT } from './endpoint';

export interface PermissionManagerServiceType {
  get: ReturnType<typeof get>;
  create: ReturnType<typeof create>;
  update: ReturnType<typeof update>;
  remove: ReturnType<typeof remove>;
}

export const initPermissionManagerService = (
  axios: AxiosInstance
): PermissionManagerServiceType => ({
  get: get(axios),
  create: create(axios),
  update: update(axios),
  remove: remove(axios),
});

export const get = (axios: AxiosInstance) => async (): Promise<PermissionModel[]> => {
  return await axios.get(`${PERMISSION_ENDPOINT}`).then(response => response.data);
};

export const create =
  (axios: AxiosInstance) =>
  async (data: PayloadRequestMutationModel): Promise<any[]> => {
    return axios.post(`${PERMISSION_ENDPOINT}`, data);
  };

export const update =
  (axios: AxiosInstance) =>
  async (data: PayloadRequestMutationModel): Promise<any[]> => {
    return axios.put(`${PERMISSION_ENDPOINT}/${data.id!}`, data);
  };

export const remove =
  (axios: AxiosInstance) =>
  async (id: number): Promise<any> => {
    return await axios.delete(`${PERMISSION_ENDPOINT}/${id}`);
  };
